import React, {FC} from "react";
import {Switch} from "@octopusdeploy/design-system-components";
import { useAutoSubscribeSettings } from "~/hooks/useAutoSubscribeSettings";
import { Select } from "../../components/form";
import { BackgroundTaskSubscriptionEvents, BackgroundTaskSubscriptionChannels } from "~/client/resources/backgroundTaskSubscriptionResource";
import { Item as SelectItem } from "../../components/form/Select/Select";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";

interface AutoSubscribeSettingsDialogProps {
    open: boolean;
    onClose: () => void;
}

export const AutoSubscribeSettingsDialog: FC<AutoSubscribeSettingsDialogProps> = ({
    open,
    onClose,
}) => {
    const { settings, setSettings } = useAutoSubscribeSettings();

    const eventsOptions: SelectItem[] = [
        {
            value: BackgroundTaskSubscriptionEvents.BackgroundTaskFailed,
            text: "Notify if the task fails"
        },
        {
            value: BackgroundTaskSubscriptionEvents.BackgroundTaskStopped,
            text: "Notify when the task completes or fails"
        },
        {
            value: BackgroundTaskSubscriptionEvents.BackgroundTaskStepCompleted,
            text: "Notify whenever a step completes"
        },
    ];

    const channelOptions: SelectItem[] = [
        {
            value: BackgroundTaskSubscriptionChannels.Slack,
            text: "Slack"
        },
    ];

    return (
        <ConfirmationDialog
            open={open}
            onClose={onClose}
            onContinueClick={async () => { onClose(); }}
            title="Auto-subscribe Settings"
            continueButtonLabel="Save"
        >
            <div style={{ minWidth: "400px" }}>
                <div style={{ marginBottom: "16px" }}>
                    <Switch 
                        value={settings.enabled}
                        onChange={(enabled: boolean) => setSettings({ ...settings, enabled })}
                        label="Auto-subscribe to background tasks I initiate"
                    />
                </div>
                
                {settings.enabled && (
                    <div>
                        <div style={{ marginBottom: "16px" }}>
                            <Select 
                                value={settings.defaultEvents}
                                onChange={(value) => setSettings({ ...settings, defaultEvents: value as BackgroundTaskSubscriptionEvents })}
                                items={eventsOptions}
                                fieldName="Default notification events"
                                label="When should you be notified?"
                            />
                        </div>
                        
                        <div>
                            <Select 
                                value={settings.defaultChannel}
                                onChange={(value) => setSettings({ ...settings, defaultChannel: value as BackgroundTaskSubscriptionChannels })}
                                items={channelOptions}
                                fieldName="Default notification channel"
                                label="How should you be notified?"
                            />
                        </div>
                    </div>
                )}
            </div>
        </ConfirmationDialog>
    );
};
